module.exports = __webpack_public_path__ + "assets/img/5.ca46b484.jpg";